import { IPromoBank } from '../../../types/newbuilding/promoInfo';

export const getBankLogoUrl = (bank: IPromoBank): string | null => {
  return bank.secondSquareImageUrl || bank.logoUrl || null;
};
